import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncYoutubeToYoutube() {
    return (
        <GuidesPage
            seoData={seoContent.syncYoutubeToYoutube}
            sections={<PairSyncGuideContent sourceKey="youtube" destKey="youtube" />}
        />
    );
}
